<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Examination Committee</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">Examination Committee</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="minority-cell ptb--100 ">
    <div class="container">
        <div class="row">
            <h4 class="yellow-color fw-bold mb-3 mt-3">Corporate Research Centre, Alumni and Entrepreneurship
                Development Cell 2023-24</h4>
            <div class="col-12">

                <div class="table-responsive">
                    <table class="table table-bordered table-striped table--4">

                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Name of the Member</th>
                                <th>Role in Committee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td>Prof. Priyanka Deshmukh</td>
                                <td>Head</td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td>Prof. Sarika Kulthe</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>3.</td>
                                <td>Prof. Rupali Raghorte</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>4.</td>
                                <td>Prof. Nilam Dhage</td>
                                <td>Teaching Representative</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br>
            <h4 class="yellow-color fw-bold mb-3 mt-3">Research , Ethics & Publication Committee
                2023-24
            </h4>
            <div class="col-12">

                <div class="table-responsive">
                    <table class="table table-bordered table-striped table--4">

                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Name of the Faculty</th>
                                <th>Designation</th>
                                <th>Role in The Committee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td>Dr. Amita Raj Gargey</td>
                                <td>Director</td>
                                <td>Chairman</td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td>Prof. Paramela Jogadande</td>
                                <td>Dean R & D</td>
                                <td>Co-ordinator (R&D)</td>
                            </tr>
                            <tr>
                                <td>3.</td>
                                <td>Dr. Mohit Raut</td>
                                <td>Asst. Prof</td>
                                <td>Member</td>
                            </tr>
                            <tr>
                                <td>4.</td>
                                <td>Prof. Sheela Satav</td>
                                <td>HoD BBA(CA) Department</td>
                                <td>Member</td>
                            </tr>
                            <tr>
                                <td>5.</td>
                                <td>Prof. Abhay Kand</td>
                                <td>HoD B.Com Department</td>
                                <td>Member</td>
                            </tr>
                            <tr>
                                <td>6.</td>
                                <td>Prof. Shainee Deb</td>
                                <td>HoD BBA Department</td>
                                <td>Member</td>
                            </tr>
                            <tr>
                                <td>7.</td>
                                <td>Prof. Ashwini Kamble</td>
                                <td>HoD B.Sc. CS Department</td>
                                <td>Member</td>
                            </tr>
                            <tr>
                                <td>8.</td>
                                <td>Prof. Kirti Nashikkar</td>
                                <td>Assistant Professor</td>
                                <td>Member</td>
                            </tr>
                            <tr>
                                <td>9.</td>
                                <td>Prof. Vaijanta Bhogawade</td>
                                <td>Assistant Professor</td>
                                <td>Member</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br>
            <h4 class="yellow-color fw-bold mb-3 mt-3">Faculty Development/ Welfare, and Innovation Cell, Lost and Found
                Committee
            </h4>
            <div class="col-12">

                <div class="table-responsive">
                    <table class="table table-bordered table-striped table--4">

                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Name of the Member</th>
                                <th>Role in Committee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td>Prof. Paramela Jogdande</td>
                                <td>Head</td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td>Prof. Kirti Nashikkar</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>3.</td>
                                <td>Prof. Vaijanta Bhogawade</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>4.</td>
                                <td>Dr. Mohit Raut</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>5.</td>
                                <td>Prof. Ashwini Kamble</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>6.</td>
                                <td>Prof. Pranali Sisodiya</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>7.</td>
                                <td>Mr. Tushar Kadlag</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>8.</td>
                                <td>Prof. Sonika Kamthe</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>9.</td>
                                <td>Prof. Rupali Raghorte</td>
                                <td>Teaching Representative</td>
                            </tr>
                            <tr>
                                <td>10.</td>
                                <td>Prof. Savita Sapkale</td>
                                <td>Teaching Representative</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
